export const useSecureAuth = () => {
  const getToken = () => {
    if (process.client) {
      try {
        const tokenData = sessionStorage.getItem('admin_token')
        if (!tokenData) return null

        const parsed = JSON.parse(tokenData)
        return parsed.token
      } catch {
        return null
      }
    }
    return null
  }

  const setToken = async (token) => {
    if (process.client) {
      try {
        const { $api } = useNuxtApp()

        await $api.post('/admin/auth/store-token', {
          token,
          expires_in: 7 * 24 * 60 * 60
        })
        const tokenData = {
          token,
          timestamp: Date.now(),
          expires: Date.now() + (7 * 24 * 60 * 60 * 1000)
        }
        sessionStorage.setItem('admin_token', JSON.stringify(tokenData))

        return true
      } catch (error) {
        console.error('Failed to store token securely:', error)
        try {
          const tokenData = {
            token,
            timestamp: Date.now(),
            expires: Date.now() + (7 * 24 * 60 * 60 * 1000)
          }
          sessionStorage.setItem('admin_token', JSON.stringify(tokenData))
        } catch (storageError) {
          console.error('Failed to store token in sessionStorage:', storageError)
        }
        return false
      }
    }
    return false
  }

  const removeToken = async () => {
    if (process.client) {
      try {
        const { $api } = useNuxtApp()
        await $api.post('/admin/auth/remove-token')
      } catch (error) {
        console.error('Failed to remove token from server:', error)
      }

      try {
        sessionStorage.removeItem('admin_token')
      } catch (error) {
        console.warn('Failed to remove token from sessionStorage:', error)
      }
    }
  }

  const isTokenExpired = () => {
    if (process.client) {
      const tokenData = sessionStorage.getItem('admin_token')
      if (!tokenData) return true

      try {
        const parsed = JSON.parse(tokenData)
        return Date.now() > parsed.expires
      } catch {
        return true
      }
    }
    return true
  }

  const refreshToken = async () => {
    if (process.client) {
      try {
        const { $api } = useNuxtApp()
        const response = await $api.post('/admin/auth/refresh')

        if (response.data?.token) {
          await setToken(response.data.token)
          return response.data.token
        }
        return null
      } catch (error) {
        console.error('Failed to refresh token:', error)
        await removeToken()
        throw error
      }
    }
    return null
  }

  const isAuthenticated = () => {
    if (process.client) {
      const token = getToken()
      if (!token) return false

      if (isTokenExpired()) {
        removeToken()
        return false
      }

      return true
    }
    return false
  }

  const validateToken = async () => {
    if (!isAuthenticated()) return false

    try {
      const { $api } = useNuxtApp()
      const response = await $api.get('/admin/auth/me')
      return response.success
    } catch (error) {
      console.error('Token validation failed:', error)
      await removeToken()
      return false
    }
  }

  return {
    getToken,
    setToken,
    removeToken,
    refreshToken,
    isAuthenticated,
    isTokenExpired,
    validateToken
  }
}
